var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app-bar",
    {
      staticClass: "custom-app-bar",
      class: !_vm.isCalculatorRoute ? "border-bottom" : "",
      attrs: { app: "", flat: "" },
    },
    [
      _c(
        "v-row",
        {
          staticClass: "mx-3 mt-1 px-2",
          class: _vm.isCalculatorRoute ? "floating-header" : "",
          staticStyle: { height: "80px" },
          attrs: { align: "center", justify: "space-between" },
        },
        [
          !_vm.isCalculatorRoute
            ? _c(
                "v-toolbar-title",
                { staticClass: "ml-5" },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0", attrs: { align: "center" } },
                    [
                      _c("img", {
                        staticClass: "main-logo",
                        attrs: {
                          src: require("../../../content/images/logo2.png"),
                          alt: "logo",
                          width: "711",
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.customer && _vm.isCalculatorRoute
            ? _c(
                "v-col",
                { staticClass: "pa-0", attrs: { cols: "9" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 flex-nowrap",
                      attrs: { align: "center", justify: "space-between" },
                    },
                    [
                      _vm.customer.firstPerson
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: { cols: "5", justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 flex-nowrap",
                                  attrs: {
                                    align: "center",
                                    justify: "space-between",
                                  },
                                },
                                [
                                  _c("lazy-auth-image", {
                                    attrs: {
                                      size: "large",
                                      "is-avatar": true,
                                      id: _vm.customer.thumbnailId,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-col", { staticClass: "pa-0" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "ma-0 text-h7 width-fit font-weight-bold w-text-75 text-overflow-dotted",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("formatPersonalInfo")(
                                                _vm.customer.firstPerson
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.customer.secondPerson
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 text-h7 width-fit font-weight-bold w-text-75 text-overflow-dotted",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._f("formatPersonalInfo")(
                                                    _vm.customer.secondPerson
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasAddress
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 font-14 width-fit text-no-wrap w-text-75 text-overflow-dotted",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._f("formatAddress")(
                                                    _vm.customer.propertyData
                                                      .objectAddress
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNotCustomerRoute && !_vm.isAdmin
            ? _c(
                "v-col",
                { attrs: { cols: "3", align: "end" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0",
                      attrs: { align: "start", justify: "space-between" },
                    },
                    [
                      _vm.isCalculatorRoute
                        ? _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { cols: "6" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "rounded-lg",
                                  attrs: {
                                    color: "secondary",
                                    elevation: "0",
                                    icon: !_vm.$vuetify.breakpoint.lgAndUp,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showQuickAccessPanel = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "d-lg-none",
                                      attrs: { size: "45" },
                                    },
                                    [_vm._v("mdi-clock-fast")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "d-none d-lg-block" },
                                    [_vm._v("Sales-Steuerung")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isCalculatorRoute ? _c("v-spacer") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "6", lg: "4" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "rounded-lg",
                              attrs: {
                                color: "primary",
                                elevation: "0",
                                loading: _vm.savingCustomer,
                              },
                              on: { click: _vm.saveAndGoToCustomerList },
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-account-multiple")]),
                              _vm._v(" "),
                              _c("p", { staticClass: "ma-0 px-2" }, [
                                _vm._v("kunden"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.customer != null &&
                          _vm.customer.customerId != null &&
                          _vm.isCalculatorRoute
                            ? _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 mt-1 subtitle-2",
                                  attrs: {
                                    align: "center",
                                    justify: "space-between",
                                  },
                                },
                                [
                                  _c("span", [_vm._v("Kd-ID:")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.customer.customerId)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showQuickAccessPanel
        ? _c("quick-access", {
            attrs: {
              "customer-id": _vm.customer.id,
              "show-dialog": _vm.showQuickAccessPanel,
              "in-calc-route": true,
            },
            on: {
              "update:showDialog": function ($event) {
                _vm.showQuickAccessPanel = $event
              },
              "update:show-dialog": function ($event) {
                _vm.showQuickAccessPanel = $event
              },
              listUpdate: _vm.handelUpdateCustomer,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }